"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.tags.placeholder': 'Enter tags separated by commas',
    'knowledge.tags.help': 'Press Enter to add each tag',
};
